import React from 'react'
import PropTypes from 'prop-types'

import ProductAnalyticsKeywordSearch from './ProductAnalyticsKeywordSearch'
import ProductAnalyticsTiersContainer from './Tiers/ProductAnalyticsTiersContainer'

function ProductAnalyticsKeywordSearchContainer({
  keywords,
  searchTerm,
  activeSearchGroup,
  modalIsOpen,
  handleSubmit,
  handleChange,
  dataFetch,
  openModal,
  closeModal,
  wordCountButtonClassName,
  handleWordCountChange,
  tiersData,
  tierRule,
  tabSwitch,
}) {
  const keywordSearchRule = tiersData.meta.tiers.find(info => info.feature === 'keyword search')

  return (
    tiersData.data.user.currentTier >= 4 ? (
      <ProductAnalyticsKeywordSearch
        keywords={keywords}
        searchTerm={searchTerm}
        activeSearchGroup={activeSearchGroup}
        modalIsOpen={modalIsOpen}
        handleSubmit={handleSubmit}
        handleChange={handleChange}
        dataFetch={dataFetch}
        openModal={openModal}
        closeModal={closeModal}
        wordCountButtonClassName={wordCountButtonClassName}
        handleWordCountChange={handleWordCountChange}
        tiersData={tiersData}
        tierRule={tierRule}
        tabSwitch={tabSwitch}
      />
    ) : (
      <ProductAnalyticsTiersContainer
        tiersData={tiersData}
        tierRule={keywordSearchRule.requiredUserLevel + 1}
        tabSwitch={tabSwitch}
      />
    )
  )
}

ProductAnalyticsKeywordSearchContainer.propTypes = {
  keywords: PropTypes.object.isRequired,
  searchTerm: PropTypes.string.isRequired,
  activeSearchGroup: PropTypes.number.isRequired,
  modalIsOpen: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  dataFetch: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  wordCountButtonClassName: PropTypes.func.isRequired,
  handleWordCountChange: PropTypes.func.isRequired,
  tiersData: PropTypes.object.isRequired,
  tierRule: PropTypes.number.isRequired,
  tabSwitch: PropTypes.func.isRequired,
}

export default ProductAnalyticsKeywordSearchContainer
